import styled, { css } from 'styled-components';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

export const FormWrapper = styled.div`
  max-width: ${({ $maxWidth }) => $maxWidth ?? '450px'};
  --checkboxStateSize: 16px;

  ${tabletBreakpoint(css`
    margin: 0 auto;
  `)}
`;

export const FormLabel = styled.span`
  ${({ theme }) => theme.typography.bodySMMedium}
  line-height: 20px;
  color: var(--colors-bayoux);

  a {
    color: var(--colors-irisBlue);

    &:hover {
      text-decoration: underline 2px;
    }
  }
`;
